import { render, staticRenderFns } from "./ClientGoodsListItem.vue?vue&type=template&id=3b3acba2&scoped=true"
import script from "./ClientGoodsListItem.vue?vue&type=script&lang=js"
export * from "./ClientGoodsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3acba2",
  null
  
)

export default component.exports